// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';
// Define a service using a base URL and expected endpoints
const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL_admin}/statement-online`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');

    // If we have a token set in state, let's assume that we should be passing it.
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const statementOnlineApi = createApi({
  reducerPath: 'statementOnlineApi',
  baseQuery,
  endpoints: (builder) => ({
    getStatementOnline: builder.query({
      query: (q) => {
        const params = [
          q.bank ? `bank=${q.bank}` : '',
          q.accountNo ? `accountNo=${q.accountNo}` : '',
          q.status ? `status=${q.status}` : '',
          q.detailStatus ? `detailStatus=${q.detailStatus}` : '',
          q.startDate ? `startDate=${q.startDate}` : '',
          q.endDate ? `endDate=${q.endDate}` : '',
          q.startEffectiveDate
            ? `startEffectiveDate=${q.startEffectiveDate}`
            : '',
          q.endEffectiveDate ? `endEffectiveDate=${q.endEffectiveDate}` : '',
          q.creditAmount ? `creditAmount=${q.creditAmount}` : '',
          q.debitAmount ? `debitAmount=${q.debitAmount}` : '',
          q.sorgcode ? `sorgcode=${q.sorgcode}` : '',
          q.search ? `search=${q.search}` : '',
          q.page ? `page=${q.page}` : '',
          q.size ? `size=${q.size}` : '',
          q.sortBy ? `sortBy=${q.sortBy}` : '',
          q.sortOrder ? `sortOrder=${q.sortOrder}` : '',
        ]
          .filter(Boolean)
          .join('&');

        return `?${params}`;
      },
      transformResponse: (response, _, arg) => ({ ...response, query: arg }),
    }),
    updateStatementOnline: builder.mutation({
      query: (req) => {
        const { params, body } = req;
        const { id } = params;
        return {
          url: `/${id}`,
          body,
          method: 'PUT',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        };
      },
    }),
    getStatementOnlineLog: builder.query({
      query: (q) => {
        const params = [
          q.bank ? `bank=${q.bank}` : '',
          q.accountNo ? `accountNo=${q.accountNo}` : '',
          q.status ? `status=${q.status}` : '',
          q.detailStatus ? `detailStatus=${q.detailStatus}` : '',
          q.startDate ? `startDate=${q.startDate}` : '',
          q.endDate ? `endDate=${q.endDate}` : '',
          q.startEffectiveDate
            ? `startEffectiveDate=${q.startEffectiveDate}`
            : '',
          q.endEffectiveDate ? `endEffectiveDate=${q.endEffectiveDate}` : '',
          q.creditAmount ? `creditAmount=${q.creditAmount}` : '',
          q.debitAmount ? `debitAmount=${q.debitAmount}` : '',
          q.sorgcode ? `sorgcode=${q.sorgcode}` : '',
          q.search ? `search=${q.search}` : '',
          q.page ? `page=${q.page}` : '',
          q.size ? `size=${q.size}` : '',
          q.sortBy ? `sortBy=${q.sortBy}` : '',
          q.sortOrder ? `sortOrder=${q.sortOrder}` : '',
        ]
          .filter(Boolean)
          .join('&');

        return `/log?${params}`;
      },
      transformResponse: (response, _, arg) => ({ ...response, query: arg }),
    }),
    reverseStatementOnline: builder.mutation({
      query: (body) => ({
        url: '/reversed',
        method: 'POST',
        body,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetStatementOnlineQuery,
  useLazyGetStatementOnlineQuery,
  useUpdateStatementOnlineMutation,
  useGetStatementOnlineLogQuery,
  useLazyGetStatementOnlineLogQuery,
  useReverseStatementOnlineMutation,
} = statementOnlineApi;
